import AdebifyProductAnalysisReducer from './reducers';

export default AdebifyProductAnalysisReducer;
